import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import ApiUrl from "../../config/app-config";

const baseURL = ApiUrl();

const TermsDetail = (props) => {
  const [data, setData] = useState({});
  const [list, setList] = useState();
  const contentId = useParams();
  const pageId = contentId.id;

  async function getData() {
    props.onIsLoading(true);
    try {
      //응답 성공
      //`${API_URL}/v1/terms/${contentId}`
      const response = await axios.get(`${baseURL}/v1/terms`, {
        params: {
          type: pageId,
        },
      });
      const success = response.data;
      const result = success.result;
      props.onIsLoading(false);
      setList(result && result.reverse());
      setData(result && result[0]);
    } catch (error) {
      //응답 실패
      props.onIsLoading(false);
      props.onError(true);
      console.error(error);
    }
  }
  useEffect(() => {
    getData();
  }, []);

  const headerUi = {
    goback: false,
    closeAll: true,
  };

  //데이터 없을때 페이지 네임 처리
  const pageName =
    pageId == 0
      ? "무버스 이용 약관"
      : pageId == 1
      ? "개인정보 수집 이용 동의"
      : pageId == 2
      ? "위치 기반 서비스 이용"
      : pageId == 3
      ? "고유식별정보 수집 이용 동의"
      : pageId == 4
      ? "마케팅 수집 이용 동의"
      : pageId == 5
      ? "본인확인 서비스 이용"
      : pageId == 6
      ? "개인정보 수집 이용 동의"
      : pageId == 7
      ? "고유식별정보 수집 이용 동의"
      : pageId == 8
      ? "통신사 이용 약관"
      : pageId == 9
      ? "차량손해면책제도 이용약관"
      : pageId == 10
      ? "개인정보 수집 및 이용 동의"
      : pageId == 11
      ? "개인정보 제3자 제공 동의"
      : pageId == 12
      ? "무버스 이용 약관"
      : // : pageId == 13
      // ? "위치기반 서비스 이용"
      pageId == 14
      ? "개인정보 처리 방침"
      : pageId == 15
      ? "개인신용정보 수집/이용 동의"
      : pageId == 16
      ? "개인신용정보 조회 동의"
      : pageId == 17
      ? "개인신용정보 제공 동의"
      : pageId == 18
      ? "개인정보 수집 이용 동의"
      : pageId == 19
      ? "개인정보 수집 이용 동의"
      : pageId == 20
      ? "고유식별정보 수집 이용 동의" 
      : pageId == 21
      ? "고유식별정보 수집 이용 동의"
      : pageId == 22
      ? "개인정보 수집 이용 동의" 
      : '개인정보 수집 이용 동의';

  useEffect(() => {
    if (data !== null) {
      switch (data.type) {
        case 0:
          data.type = "무버스 이용 약관";
          break;
        case 1:
          data.type = "개인정보 수집 이용 동의";
          break;
        case 2:
          data.type = "위치 기반 서비스 이용";
          break;
        case 3:
          data.type = "고유식별정보 수집 이용 동의";
          break;
        case 4:
          data.type = "마케팅 수집 이용 동의";
          break;
        case 5:
          data.type = "본인확인 서비스 이용약관";
          break;
        case 6:
          data.type = "개인정보 수집 이용 동의";
          break;
        case 7:
          data.type = "고유식별정보 수집 이용 동의";
          break;
        case 8:
          data.type = "통신사 이용 약관";
          break;
        case 9:
          data.type = "차량손해면책제도 이용약관";
          break;
        case 10:
          data.type = "개인정보 수집 이용 동의";
          break;
        case 11:
          data.type = "개인정보 제3자 제공 동의";
          break;
        case 12:
          data.type = "무버스 이용 약관";
          break;
        // case 13:
        //   data.type = "위치기반 서비스 이용";
        //   break;
        case 14:
          data.type = "개인정보 처리 방침";
          break;
        case 15:
          data.type = "개인신용정보 수집/이용 동의";
          break;
        case 16:
          data.type = "개인신용정보 조회 동의";
          break;
        case 17:
          data.type = "개인신용정보 제공 동의";
          break;
        case 18:
          data.type = "개인정보 수집 이용 동의";
          break;
        case 19:
          data.type = "개인정보 수집 이용 동의";
          break;
        case 20:
          data.type = "고유식별정보 수집 이용 동의";
          break;
        case 21:
          data.type = "고유식별정보 수집 이용 동의";
          break;
        case 22:
          data.type = "개인정보 수집 이용 동의";
          break;
        default:
          break;
      }
      props.onPageName(data.type);
    } else if (data === null) {
      props.onPageName(pageName);
    }
  }, [data]);
  useEffect(() => {
    props.onHeaderUi(headerUi);
  }, []);

  const onChangeData = (e) => {
    setData(list[e.target.value]);
  };
  /**list 데이터 받아오기 */
  const [content, setContent] = useState();
  useEffect(() => {
    setContent(data && data.content);
  }, [data, list]);
  const termsContent = content;
  function createMarkup() {
    return { __html: termsContent };
  }

  return (
    <div className="container terms_wrap">
      {data !== null ? (
        <>
          {(pageName && pageName === "무버스 이용 약관") ||
          pageName === "개인정보 처리 방침" ||
          pageName === "위치 기반 서비스 이용" ||
          pageName === "무버스 이용 약관" ||
          pageName === "위치기반 서비스 이용" ||
          pageName === "차량손해면책제도 이용약관" ? (
            <div className="before_terms">
              <div>이전 약관 보기</div>
              <select onChange={onChangeData}>
                {list &&
                  list.map((item, index) => {
                    const createDate = item && item.createdDate.split("T")[0];
                    return (
                      <option key={index} value={index}>
                        {createDate}
                      </option>
                    );
                  })}
              </select>
            </div>
          ) : null}
          <div
            className="font-content"
            dangerouslySetInnerHTML={createMarkup()}
          ></div>
        </>
      ) : (
        <div className="no_list">
          <h5>약관 내역이 없습니다.</h5>
        </div>
      )}
    </div>
  );
};
export default TermsDetail;
